class CartUpdater {
  constructor() {
    this.sectionConfig = {
      'main-cart-items': { selector: 'cart-items', updateMethod: this.updateMainCart }
    };
    this.attachEventListeners();
    this.lastFocusedItemKey = null;
  }

  attachEventListeners() {
    document.addEventListener('cartUpdated', this.handleCartUpdate.bind(this));
  }

  handleCartUpdate(event) {
    const { detail } = event;
    if (!detail || !detail.updatedCartHtml || typeof detail.updatedCartHtml !== 'object') {
      console.error('Invalid event detail or updatedCartHtml:', detail);
      return;
    }
    const sections = detail.updatedCartHtml;
    const updatePromises = [];
    for (const [sectionName, html] of Object.entries(sections)) {
      if (this.sectionConfig[sectionName]) {
        updatePromises.push(this.sectionConfig[sectionName].updateMethod.call(this, html, sectionName));
      } else {
        console.warn(`No update method found for section: ${sectionName}`);
      }
    }
    Promise.all(updatePromises).then(() => {
      if (this.lastFocusedItemKey) {
        this.scrollToItem(this.lastFocusedItemKey);
      }
      document.dispatchEvent(new CustomEvent('cartUpdateCompleted', { detail: detail.cartData }));
      this.lastFocusedItemKey = null;
    });
  }

  updateMainCart(html, sectionName) {
    return new Promise((resolve) => {
      const mainCart = document.querySelector('cart-items');
      if (mainCart) {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        const newMainCart = tempDiv.querySelector('cart-items');
        if (newMainCart) {
          mainCart.innerHTML = newMainCart.innerHTML;
          this.reinitializeMultishipForms(mainCart);
        } else {
          console.log(`New cart-items content not found in the updated HTML for section: ${sectionName}. Skipping update.`);
        }
      } else {
        console.log(`Main cart element not found in the document for section: ${sectionName}. Skipping update.`);
      }
      resolve();
    });
  }

  reinitializeMultishipForms(container) {
    const forms = container.querySelectorAll('multiship-address-form, multiship-shipping-form, gift-message-form');
    console.log(`Found ${forms.length} multiship forms to reinitialize`);
    forms.forEach(form => {
      if (typeof form.initialize === 'function') {
        form.initialize();
      } else {
        console.log('initialize method not found on form. Skipping reinitialization.');
      }
    });
  }

  reattachCartDrawerListeners(cartDrawer) {
    const closeButton = cartDrawer.querySelector('.drawer__close');
    if (closeButton) {
      closeButton.onclick = () => cartDrawer.close();
    }

    const checkoutButton = cartDrawer.querySelector('#CartDrawer-Checkout');
    if (checkoutButton) {
      checkoutButton.onclick = (event) => {
        event.preventDefault();
        const form = cartDrawer.querySelector('#CartDrawer-Form');
        if (form) {
          form.submit();
        }
      };
    }
  }

  scrollToItem(itemKey) {
    const itemElement = document.querySelector(`[data-item-key="${itemKey}"]`);
    if (itemElement) {
      itemElement.scrollIntoView({
        block: 'nearest',
        inline: 'nearest'
      });
    }
  }
}

// Initialize the CartUpdater
document.addEventListener('DOMContentLoaded', () => {
  new CartUpdater();
});
